import { createContext, useContext } from 'react';

import { WizardPageAction } from '../store/wizard/wizard';

export type PagesContextProviderValues = {
    /**
     * The current page step to be shown
     */
    currentPage: number;

    /*
     * Set the current page step
     * @param step the page step number to show
     */
    setCurrentPage: (step: number) => void;

    /**
     * The total number of steps
     */
    numberOfPages: number;

    /**
     * The step action that was used to show this page
     */
    pageAction: WizardPageAction;

    /**
     * Sets the current step action
     *
     * @param action the action that was used
     */
    setPageAction: (action: WizardPageAction) => void;

    sectionTitle: string;
    setSectionTitle: (title: string) => void;

    currentSection: number;
    setCurrentSection: (section: number) => void;

    numberOfSections: number;

    setNumberOfSections: (sections: number) => void;
};

const defaultContext: PagesContextProviderValues = {
    currentPage: 0,
    setCurrentPage: () => {},
    numberOfPages: 0,
    pageAction: 'next',
    setPageAction: () => {},
    currentSection: 0,
    setCurrentSection: () => {},
    numberOfSections: 0,
    setNumberOfSections: () => {},
    sectionTitle: '',
    setSectionTitle: () => {},
};

export const PagesContext = createContext<PagesContextProviderValues>(defaultContext);

export const usePagesContext = () => useContext(PagesContext);
